module.exports = __webpack_public_path__ + "img/logo_so.f3155509.png";